export default {
  data() {
    return {
      pageSizes: [20, 50, 100, 200],
      pageNum: 1,
      pageSize: 10,
      pagerCount: 5,
      layout: "total, jumper,prev, pager,next",
      total: 0
    };
  },

  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getData();
    },

    handlePageChange(page) {
      this.pageNum = page;
      this.getData();
    }
  }
};
